import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

console.log("[BOOT] main.tsx loaded", new Date().toISOString());

const el = document.getElementById("root");
if (!el) throw new Error("root not found");

console.log("[BOOT] about to render");
ReactDOM.createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);